import PropTypes from 'prop-types';
import { useState, useRef, useCallback, useEffect } from 'react';
import ReactPlayer from 'react-player';
import { StyledVideoContainer } from './styles';
import { resolveVideoRatio } from './videoRatio';

const Video = ({ style, url,  type='Video', title = '', legend, legendSize = null, timeStart, forcePause = false, pinnedRatio = null, onRatioDetected = null }) => {
  const [isClient, setIsClient] = useState(false);
  const [isReady, setIsReady] = useState(false);
  const playerRef = useRef();
  const [detectedRatio, setDetectedRatio] = useState(null);

  useEffect(() => {
    setIsClient(true);
  }, []);

  const getIsLinkVimeo = () => {
    return url.includes('https://vimeo.com/');
  };

  useEffect(() => {
    if (!forcePause) return;
    const internalPlayer = playerRef.current?.getInternalPlayer();
    if (!internalPlayer) return;
    if (typeof internalPlayer.pauseVideo === 'function') internalPlayer.pauseVideo();
    else if (typeof internalPlayer.pause === 'function') internalPlayer.pause();
  }, [forcePause]);

  const onReady = useCallback(() => {
    const player = playerRef.current?.getInternalPlayer();
    if (player && typeof player.getVideoWidth === 'function') {
      Promise.all([player.getVideoWidth(), player.getVideoHeight()])
        .then(([width, height]) => {
          if (!(width > 0 && height > 0)) return;
          setDetectedRatio(height / width);
          if (onRatioDetected) onRatioDetected(height / width);
        })
        .catch(() => {});
    }
    if (!isReady && Number(timeStart) > 0) {
      playerRef.current.seekTo(Number(timeStart), 'seconds');
      setIsReady(true);
    }
  }, [isReady, timeStart, onRatioDetected]);

  if (!isClient) {
    return null;
  }

  return (
    <>
      {title && (
        <h2
          style={{
            margin: '0 0 10px 45px',
            fontSize: '24px',
            fontWeight: '600',
            color: '#333',
            justifySelf: 'center',
          }}
        >
          {title}
        </h2>
      )}
      <StyledVideoContainer $ratio={resolveVideoRatio(url, style, detectedRatio, pinnedRatio)} $hasLegend={!!legend}>
        {getIsLinkVimeo() ? (
          <ReactPlayer
            className="react-player"
            ref={playerRef}
            url={url}
            height="100%"
            width="100%"
            controls
            onReady={onReady}
          />
        ) : (
          <ReactPlayer
            className="react-player"
            ref={playerRef}
            url={url}
            height="100%"
            width="100%"
            controls
          />
        )}
      </StyledVideoContainer>
      {legend && legend.length > 0 && (
        <div style={{ marginBottom: '20px' }}>
          <legend
            style={{ fontSize: legendSize ? (legendSize === 'small' ? '13px' : '16px') : '13px' }}
          >
            {legend}
          </legend>
        </div>
      )}
    </>
  )
};

Video.propTypes = {
  legend: PropTypes.string,
  style: PropTypes.object,
  url: PropTypes.string,
  timeStart: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  forcePause: PropTypes.bool,
  pinnedRatio: PropTypes.string,
  onRatioDetected: PropTypes.func,
};

export default Video;
